import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";

export default function SaitCheckboxColumn(props) {
	return {
		headerName: props.header,
		field: props.field,
		width: props.width || 45,
		sortable: false,
		disableColumnMenu: true,
		hidden: props.hidden || false,
		rifValue: props.rifValue,
		display: "flex",
		objmod: props.objmod,
		startPinned: props.startPinned,
		endPinned: props.endPinned,
		renderCell: (params) => {
			if (params.value) {
				if (params.value === "Y") {
					return (
						<Box
							sx={{
								flexGrow: 1,
								display: "inline-flex",
								justifyContent: "center",
							}}
						>
							<CheckIcon color="success" type="CheckIcon" />
						</Box>
					);
				} else if (!props.checkOnly) {
					return (
						<Box
							sx={{
								flexGrow: 1,
								display: "inline-flex",
								justifyContent: "center",
							}}
						>
							<CloseIcon color="error" type="CloseIcon" />
						</Box>
					);
				} else {
					return null;
				}
			}
		},
	};
}
